import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './datagrid.html';
import fbtemplate from './builder/preview.html';

const datagridConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
	/** @type {any} */ FORM_OPTIONS,
) => {
	KformComponentsProvider.register('datagrid', {
		fbtemplate,
		icon: 'fa fa-th',
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.themes = FORM_OPTIONS.themes;
			if (!$scope.component.addAnotherPosition) {
				$scope.component.addAnotherPosition = 'bottom';
			}
			$scope.addAnotherPosition = [
				{
					value: 'top',
					title: 'Top',
				},
				{
					value: 'bottom',
					title: 'Bottom',
				},
				{
					value: 'both',
					title: 'Both',
				},
			];
		},
		views: [
			{
				name: 'Display',
				template: 'kform/components/datagrid/display.html',
			},
			{
				name: 'Validation',
				template: 'kform/components/datagrid/validate.html',
			},
			{
				name: 'API',
				template: 'kform/components/common/api.html',
			},
			{
				name: 'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		noDndOverlay: true,
		confirmRemove: true,
		title: 'Data Grid',
		template,
		group: 'advanced',
		// tableView(data, options) {
		// 	let view = '<table class="table table-striped table-bordered table-child">';
		//
		// 	if (!options.tableChild) {
		// 		view += '<thead><tr>';
		// 		angular.forEach(options.component.components, component => {
		// 			view += `<th>${ component.label || `( ${component.key})`}</th>`;
		// 		});
		// 		view += '</tr></thead>';
		// 	}
		//
		// 	view += '<tbody>';
		// 	angular.forEach(data, row => {
		// 		view += '<tr>';
		// 		formioUtils.eachComponent(options.component.components, component => {
		// 			// If the component has a defined tableView, use that, otherwise try and use the raw data as a string.
		// 			const info = options.componentInfo.components.hasOwnProperty(component.type) ?
		// 				options.componentInfo.components[component.type] :
		// 				{};
		// 			if (info.tableView) {
		// 				// Reset the tableChild value for datagrids, so that components have headers.
		// 				view += `<td>${ info.tableView((row && row[component.key]) || '', {
		// 					component,
		// 					$interpolate: options.$interpolate,
		// 					componentInfo: options.componentInfo,
		// 					tableChild: false,
		// 					util: options.util,
		// 				}) }</td>`;
		// 			}
		// 			else {
		// 				view += '<td>';
		// 				if (component.prefix) {
		// 					view += component.prefix;
		// 				}
		// 				view += (row && row[component.key]) || '';
		// 				if (component.suffix) {
		// 					view += ` ${ component.suffix}`;
		// 				}
		// 				view += '</td>';
		// 			}
		// 		});
		// 		view += '</tr>';
		// 	});
		// 	view += '</tbody></table>';
		// 	return view;
		// },
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
		) => {
			if ($scope.options && $scope.options.building) {
				return;
			}
			// Ensure each data grid has a valid data model.
			$scope.data = $scope.data || {};
			$scope.data[$scope.component.key] = $scope.data[$scope.component.key] || [{}];

			// Determine if any component is visible.
			$scope.anyVisible = (/** @type {any} */ component) => {
				const data = $scope.data[$scope.component.key] || [{}];
				let visible = false;
				for (const rowData of data) {
					visible = (
						visible || kformUtils.isVisible(component, rowData, $scope.data, $scope.hideComponents, $scope.form)
					);
				}
				return visible;
			};

			// Pull out the rows and cols for easy iteration.
			$scope.rows = $scope.data[$scope.component.key];
			// If less than minLength, add that many rows.
			if ($scope.component.validate?.minLength && $scope.rows.length < $scope.component.validate.minLength) {
				const toAdd = $scope.component.validate.minLength - $scope.rows.length;
				for (let index = 0; index < toAdd; index++) {
					$scope.rows.push({});
				}
			}
			// If more than maxLength, remove extra rows.
			if ($scope.component.validate?.maxLength && $scope.rows.length > $scope.component.validate.maxLength) {
				$scope.rows.splice($scope.component.validate.maxLength);
			}
			$scope.cols = $scope.component.components;
			$scope.localKeys = $scope.component.components.map((/** @type {any} */ component) => component.key);

			// Add a row the to grid.
			$scope.addRow = () => {
				if (!Array.isArray($scope.rows)) {
					$scope.rows = [];
				}
				$scope.rows.push({});
				$timeout(() => {
					angular.element(`#form-group-${$scope.component.key}`)?.trigger('rowAdded');
				});
			};

			// Remove a row from the grid.
			$scope.removeRow = (/** @type {number} */ index) => {
				$scope.rows.splice(index, 1);

				// sets the form in dirty state (because it doesn't do it!)
				if ($scope.$parent.$parent.kformForm) {
					$scope.$parent.$parent.kformForm.$setDirty();
				}
				$timeout(() => {
					angular.element(`#form-group-${$scope.component.key}`)?.trigger('rowRemoved');
				});
			};
		},
		children:   false,
		selectable: true,
		settings: {
			autofocus: false,
			bordered: false,
			disabled: false,
			input: true,
			components: [],
			tableView: true,
			label: 'Data Grid',
			hideLabel: false,
			key: 'datagrid',
			protected: false,
			persistent: true,
			hidden: false,
			clearOnHide: true,
		},
	});
};

export default angular.module('app').config(datagridConfig);
